// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import keycloak from '@/api/keycloak'
import { ensureWelcomeCredit } from '@/api/credits'
import {
  clearAnalyticsUser,
  initializeFirebaseAnalytics,
  setAnalyticsUser
} from '@/api/firebaseAnalytics'
import '@/assets/global.css'
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App)

app.use(router)
app.use(ElementPlus)
app.provide('keycloak', keycloak)

initializeFirebaseAnalytics()

keycloak.init({
  onLoad: 'check-sso',
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  checkLoginIframe: false,
  relativeUrls: false
})
  .then(authenticated => {
    if (authenticated) {
      // User is authenticated - save to localStorage
      localStorage.setItem('auth_token', keycloak.token || '')
      localStorage.setItem('userId', keycloak.tokenParsed?.sub || '')

      const email = keycloak.tokenParsed?.email
        || keycloak.idTokenParsed?.email || ''
      localStorage.setItem('email', email)

      const username = keycloak.tokenParsed?.preferred_username ||
        keycloak.idTokenParsed?.preferred_username || ''
      localStorage.setItem('username', username)

      setAnalyticsUser({
        userId: keycloak.tokenParsed?.sub || '',
        username,
        email
      })

      console.log('✅ User authenticated:', username)

      ensureWelcomeCredit()
        .then(result => {
          if (result?.status === 'success') {
            console.log('Welcome credits ready:', result.granted_amount)
          }
        })
        .catch(err => {
          console.warn('Failed to set up welcome credits:', err)
        })
    } else {
      // User is not authenticated - clear localStorage
      localStorage.setItem('auth_token', '')
      localStorage.setItem('userId', '')
      localStorage.setItem('username', '')
      localStorage.setItem('email', '')

      clearAnalyticsUser()

      console.log('❌ User not authenticated')
    }

    // Always mount the app regardless of authentication status
    app.mount('#app')
  })
  .catch(err => {
    console.error('Keycloak init failed:', err)

    // Clear localStorage on error
    localStorage.setItem('auth_token', '')
    localStorage.setItem('userId', '')
    localStorage.setItem('username', '')
    localStorage.setItem('email', '')

    clearAnalyticsUser()

    // Still mount the app
    app.mount('#app')
  })
